<template>
    <main class="h-screen flex items-start bg-white">
        <sideBar/>
      <div class="app-width h-full flex flex-col">
        <appBar />
        <div class="w-full overflow-x-hidden">
          <router-view v-slot="{Component}">
            <Transition @enter="enter" @leave="leave" mode="out-in">
              <component :is="Component"/>
            </Transition>
          </router-view>
        </div>
      </div>
  </main>
</template>
<script>
import sideBar from '@/components/nav/side-bar.vue';
import appBar from '@/components/nav/app-bar.vue';
import gsap from "gsap";
export default {
    components: {
      sideBar,
      appBar
    },
    created(){
      // this.$store.dispatch("tryLogin");
    },
    methods: {
      enter(el, done){
            gsap.fromTo(el,
            { opacity: 0 }, {
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leave(el, done){
            gsap.to(el, {
                opacity: 0,
                duration: 0.15,
                ease: "power2.in",
                onComplete: done,
            });
        },
  }
}
</script>